const { TYPES: modelTypes } = require('shared/model-types')

const TEMPLATE_ITEM_REGEXP = /(\{\d+\})/

function parseTemplate({ template, items }) {
  if (template) {
    return template.split(TEMPLATE_ITEM_REGEXP)
    .map(templatePart => {
      if (TEMPLATE_ITEM_REGEXP.test(templatePart)) {
        const index = +templatePart.slice(1, -1)
        const item = items[index]
        return itemHtml(item)
      }
      return templatePart
    })
    .join('')
  }
}

function itemHtml(item) {
  return `<a class="meta-template-item" href="${itemHref(item)}">${itemText(item)}</a>`
}

function itemHref(item) {
  if (item.pageUrl) {
    return item.pageUrl
  }
  switch (item.type) {
    case modelTypes.INTEREST:
      return `/interest/${item.key}`
    case modelTypes.USER:
      return `/${item.username}`
    case modelTypes.MIX:
      return `/${item.username}/${item.slug}`
    default:
      throw new Error(`Unknown item.type: ${item.type}`)
  }
}

function itemText(item) {
  switch (item.type) {
    case modelTypes.USER:
      return `@${item.username}`
    default:
      return item.name
  }
}

module.exports = {
  parseTemplate
}
